import { useSubscriptionSync } from "@/hooks/useSubscriptionSync";

export function SubscriptionSyncGate() {
  useSubscriptionSync();
  return null;
}
